<template>
  <div v-if="isLoading || !isEdit || !empty(postInfo)">
    <a-card class="style1 post w-100" :class="[isDesktop ? 'desktop' : 'mobile']">
      <a-form :form="form" :label-col="isDesktop ? { span: 4 } : {}" :wrapper-col="isDesktop ? { span: 20 } : {}" :layout="isDesktop ? 'horizontal' : 'vertical'" @submit="handleSubmit">
        <a-form-item label="Title">
          <a-input
            @change="onGenerateSlug"
            v-decorator="[
              'title',
              {
                rules: [
                  {
                    required: true,
                    message: 'Please input title!',
                  },
                ],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="Slug">
          <a-input
            v-decorator="[
              'slug',
              {
                rules: [
                  {
                    required: true,
                    message: 'Please input post slug!',
                  },
                ],
              },
            ]"
          ></a-input>
        </a-form-item>
        <a-form-item label="content">
          <wysiwyg
            v-model="content"
            v-decorator="[
              'content',
              {
                rules: [
                  {
                    required: true,
                    validator: (rule, value, callback) => validateInput(rule, value, callback, 'Please input content!'),
                  },
                ],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="Embed">
          <a-row :gutter="20">
            <a-col :span="isDesktop ? 8 : 24">
              <a-textarea v-decorator="['embed']" :rows="10" @change="onChangeEmbed" />
              <a-button type="primary" :disabled="empty(embed)" @click.prevent="showEmbedPreview">{{ showPreview ? 'Hide preview' : 'Preview' }}</a-button>
            </a-col>
            <a-col :span="isDesktop ? 16 : 24">
              <div v-if="showPreview" v-html="embed"></div>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 20, offset: 4 }">
          <a-tag color="red" class="d-block p-1" v-if="!empty(error)">{{ error }}</a-tag>
          <a-button type="primary" html-type="submit" :loading="isLoading">{{ isEdit ? 'Update Post' : 'Create Post' }}</a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </div>
  <div v-else>
    <h2>Video not found</h2>
    <a-button type="primary" class="mb-3" @click="$router.push({ name: 'AdminPost' })">Go to videos list</a-button>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import AdminService from '@/services/AdminService';
import { empty, slugData } from '@/utils';
import { get, find } from 'lodash';
export default {
  data() {
    return {
      showPreview: false,
      error: '',
      postInfo: {},
      isLoading: false,
      embedIcon: [],
      embedThumbnail: [],
      background: [],
      thumbnail: [],
      imgLocation: '',
      imageCropped: '',
      hasChange: {},
      hasCropped: {},
      content: '',
      embed: '',
      typeLoading: 'submit',
      percentLoading: 0,
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, {
      name: 'post',
    });
  },
  computed: {
    ...mapState(['settings']),
    isEdit() {
      return this.$route.name === 'AdminPostDetail';
    },
    isDesktop() {
      return !this.settings.isMobileView && !this.settings.isTabletView;
    },
  },
  watch: {
    $route: {
      async handler(route) {
        if (this.isEdit) {
          this.doGetPostInfo(route.params.postSlug);
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.$title = this.$route.meta.title;
  },
  methods: {
    empty,
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    onGenerateSlug() {
      this.$nextTick(() => {
        this.form.setFieldsValue({
          slug: slugData(this.form.getFieldValue('title'), '-'),
        });
      });
    },
    onChangeEmbed(val) {
      this.embed = this.form.getFieldValue('embed');
    },
    showEmbedPreview() {
      if (this.showPreview) {
        this.showPreview = false;
      } else {
        this.embed = this.form.getFieldValue('embed');
        this.showPreview = true;
      }
    },
    async doGetPostInfo(postSlug) {
      try {
        this.isLoading = true;
        const resp = await AdminService.post.getAll();
        this.postInfo = find(resp, item => item.slug === postSlug);
        this.doInitData();
      } catch (error) {
        console.error({ error });
      } finally {
        this.isLoading = false;
      }
    },

    async doInitData() {
      if (this.isEdit) {
        this.content = this.postInfo.content;
        this.embed = this.postInfo.embed;
        this.showPreview = !empty(this.embed);

        this.$nextTick(() => {
          this.form.setFieldsValue({
            title: this.postInfo.title,
            slug: this.postInfo.slug,
            embed: this.postInfo.embed,
            content: this.content,
          });
        });
      }
    },
    validateInput(rule, value, callback, message) {
      if (empty(value) || value === '<br>') {
        return callback(message);
      }
      callback();
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async (err, values) => {
        if (!err) {
          try {
            this.isLoading = true;
            this.error = '';
            const dataSubmit = {};

            const paramsRequired = ['content', 'title', 'slug', 'embed'];

            paramsRequired.forEach(item => {
              if (!empty(values[item])) {
                dataSubmit[item] = values[item];
              }
            });

            this.typeLoading = 'submit';
            if (!this.isEdit) {
              await AdminService.post.create(dataSubmit);
              this.$notification['success']({
                message: 'Create successful.',
                description: `${dataSubmit.title} was created successfully.`,
              });
            } else {
              await AdminService.post.update(this.postInfo.id, dataSubmit);
              this.$emit('onSuccess');
              this.$notification['success']({
                message: 'Update successful.',
                description: `${dataSubmit.title} was updated successfully.`,
              });
            }
            this.$router.push({ name: 'AdminPost' });
          } catch (error) {
            console.log(error);
            this.error = get(error, 'response.data.error', error.message);
          } finally {
            this.isLoading = false;
          }
        } else {
          window.parent.scrollTo(0, 0);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.content-page {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
</style>
<style lang="scss">
.pages {
  &.mobile {
    .editr--toolbar {
      height: 100%;
      flex-wrap: wrap;
      .vw-btn-separator {
        display: none;
      }
    }
  }
}
</style>
